<template>
  <v-col class="search-content">
    <v-row class="mb-4">
      <v-col>
        <h1 class="headline font-weight-bold mb-2">
          Search and Selected Context
        </h1>
        <p class="body-1 coolgray--text mb-0">
          Global search helps users jump quickly across routes while keeping
          context aligned with the active network, team, person, or project.
        </p>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'magnifying-glass']"
              class="info--text mr-2"
            />
            How Search Works
          </h2>

          <ul class="body-2 mb-0">
            <li class="mb-2">
              <strong>Scope:</strong> Networks, teams, people, projects,
              and documentation routes.
            </li>
            <li class="mb-2">
              <strong>Current Page:</strong> Shows selected context for orientation.
            </li>
            <li class="mb-2">
              <strong>Recent:</strong> Reopen common destinations quickly.
            </li>
            <li>
              <strong>Quick Actions:</strong> Access frequent routes without typing.
            </li>
          </ul>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'keyboard']"
              class="primary--text mr-2"
            />
            Keyboard Support
          </h2>

          <ul class="body-2 mb-0">
            <li class="mb-2">
              Press <code>/</code> to focus search when not inside an input field.
            </li>
            <li class="mb-2">
              Use arrow keys to move through result options.
            </li>
            <li class="mb-2">
              Press Enter to navigate to the highlighted result.
            </li>
            <li>
              Press Escape to clear or close the dropdown depending on state.
            </li>
          </ul>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'circle-info']"
              class="success--text mr-2"
            />
            Testing Guidance
          </h2>

          <p class="body-2 mb-3">
            For end-to-end validation criteria, use the Search QA checklist.
          </p>

          <v-btn
            outlined
            class="text-none"
            to="/docs/test/search"
          >
            <font-awesome-icon
              :icon="['fas', 'list-check']"
              class="mr-2"
              size="sm"
            />
            Open Search QA Checklist
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'SearchContent',
}
</script>

<style lang="scss" scoped>
.search-content {
  max-width: 900px;
}

ul {
  padding-left: 20px;
}
</style>
